import { PrescriptionService } from '@/services/prescription.service';
export default {
  props: {
    prescriptionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showDialog: false,
      alert: {
        show: false,
        message: ''
      },
      processing: false
    };
  },
  methods: {
    showAlert(msg) {
      this.alert.show = true;
      this.alert.message = msg;
    },
    async onRushPrescription() {
      this.alert.show = false;
      try {
        this.processing = true;
        await PrescriptionService.bypassDelay(this.prescriptionData.id);
        this.processing = false;
        this.showDialog = false;
        setTimeout(() => {
          this.$emit('refresh-prescriptions', 'rush');
        }, 2000);
      } catch (err) {
        this.showAlert(err);
        this.processing = false;
      }
    }
  }
};